'use client'
import React from 'react'
import { PageLayoutWidth } from '../PageLayout'

type SidebarRightLayoutProps = {
    width: PageLayoutWidth
    children: React.ReactNode
    sidebarChildren?: React.ReactNode | React.ReactNode[]
}

export const SidebarRightLayout = ({ children, sidebarChildren, width }: SidebarRightLayoutProps) => {
    return (
        <>
            <div className="sidebar-right-layout spacing-page-x grid grow">
                <main className={`app-content w-full grow overflow-auto h-full`}>
                    <div className={`spacing-page-x grow flex flex-col w-full mx-auto min-h-full ${width}`}>
                        {children}
                    </div>
                </main>
                <aside className="app-sidebar flex-shrink-0 max-h-full overflow-auto correct-spacing-page--right">
                    {sidebarChildren}
                </aside>
            </div>
        </>
    )
}
